import api from '../../api'

export const getFields = () => {
  return api.get('/general/fields')
}
